import React from 'react';

import { Box, Paper, Skeleton, Typography, TypographyProps } from '@mui/material';

import { SxProp } from 'src/types/mui';

export type DashboardCardProps = CardVariantOne | CardVariantTwo;

export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  loading,
  valueTextProps,
  ...restProps
}) => {
  return (
    <Paper sx={paperStyles} variant="outlined">
      <Typography variant="body2" component={Box} noWrap>
        {title}
      </Typography>
      <Typography fontWeight="bold" variant="h4" component={Box} {...valueTextProps}>
        {loading ? <Skeleton width={50} /> : value}
      </Typography>
      <Box>
        {'description' in restProps ? (
          <Typography
            component="span"
            variant="body2"
            sx={{ color: restProps.color || (theme => theme.palette.text.secondary) }}
          >
            {loading ? <Skeleton width={200} /> : restProps.description}
          </Typography>
        ) : (
          <React.Fragment>
            {loading ? (
              <Skeleton width={200} />
            ) : (
              <React.Fragment>
                <Typography
                  sx={{ color: restProps.firstColor || (theme => theme.palette.success.main) }}
                  component="span"
                >
                  {restProps.firstValue}
                </Typography>{' '}
                /{' '}
                <Typography
                  component="span"
                  sx={{ color: restProps.secondColor || (theme => theme.palette.text.secondary) }}
                >
                  {restProps.secondValue}
                </Typography>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </Box>
    </Paper>
  );
};

const paperStyles: SxProp = {
  px: 3,
  py: 2,
  borderRadius: 2,
  flexBasis: 0,
  flexGrow: 1,
  minWidth: 250,
  gap: 0.5,
  display: 'flex',
  flexDirection: 'column',
};

type CardBase = {
  title: string;
  value: string | number;
  valueTextProps?: TypographyProps;
  loading?: boolean;
};

interface CardVariantOne extends CardBase {
  description: React.ReactNode;
  color?: unknown;
}

interface CardVariantTwo extends CardBase {
  firstValue: string | number;
  secondValue: string | number;
  firstColor?: unknown;
  secondColor?: unknown;
}
